// import firebase from 'firebase';

export const initializeFirebase = async (fn) => {
  // firebase.initializeApp({
  //   apiKey: 'AIzaSyAH8LOxd96HBbWw5-bM4TbJl1bbnxAoqwc',
  //   projectId: 'pagehitsio',
  //   messagingSenderId: '1072926039210',
  //   appId: '1:1072926039210:web:e0ca59e602fbb8229144d3',
  // });
  //
  // const messaging = firebase.messaging();
  // messaging.usePublicVapidKey('BGWbAKMbt8qCHL2Rw0Xa8WxLjLCqoGV3-yH3Tktk0FEQggbWwoUiHTRETWMw3PlfEaP330K0P2XkZ-sczIoXvnM');
  //
  // messaging.requestPermission()
  //   .then(() => {
  //     messaging.getToken().then((token) => {
  //       fn(token);
  //     });
  //   })
  //   .catch((err) => {
  //     fn(null);
  //   });
  //
  //
  // messaging.onTokenRefresh(() => {
  //   messaging.getToken().then((refreshedToken) => {
  //     fn(refreshedToken);
  //   }).catch((err) => {
  //     fn(null);
  //   });
  // });


};



// WEBPACK FOOTER //
// ./scripts/modules/pushNotification.js